module.exports = __webpack_public_path__ + "static/media/r23.87957c4d.png";